import { OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
var Formulario58Component = /** @class */ (function () {
    function Formulario58Component() {
        this.htmlcanvas = html2canvas;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.region = GLOBAL.region;
        this.archivo_demolicion = false;
        this.pages = [1, 2, 3];
    }
    Formulario58Component.prototype.ngOnInit = function () {
        this.demolicion = JSON.parse(localStorage.getItem('tipo_autorizacion'));
        if (this.demolicion.length == 0 || this.demolicion == null) {
            this.archivo_demolicion = false;
            localStorage.setItem('archivo_demolicion', 'false');
        }
        else {
            if (this.demolicion[0].autorizacion.DEMOLICION == true || this.demolicion[0].autorizacion.DEMOLICION == "true") {
                this.archivo_demolicion = true;
                localStorage.setItem('archivo_demolicion', 'true');
            }
            else {
                localStorage.setItem('archivo_demolicion', 'false');
                this.archivo_demolicion = false;
            }
        }
    };
    Formulario58Component.prototype.ngAfterContentChecked = function () {
        this.ngAfterContentInit();
    };
    Formulario58Component.prototype.ngAfterContentInit = function () {
        //PROPIEDAD
        if (JSON.parse(localStorage.getItem("propiedad"))) {
            if (JSON.parse(localStorage.getItem("propiedad")).length > 0) {
                this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
            }
            else {
                localStorage.setItem("propiedad", JSON.stringify([]));
                this.propiedad = [{ rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', recordId: '' }];
            }
        }
        //PROPIETARIOS
        if (JSON.parse(localStorage.getItem("propietarios"))) {
            if (JSON.parse(localStorage.getItem("propietarios")).length > 0) {
                this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
            }
            else {
                localStorage.setItem("propietarios", JSON.stringify([]));
                this.propietarios = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //PERMISO NOTARIADO
        if (JSON.parse(localStorage.getItem("permiso_notariado"))) {
            if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0) {
                this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
            }
            else {
                localStorage.setItem("permiso_notariado", JSON.stringify([]));
                this.permiso_notariado = [{ acreditacion: '', fecha: null, escritura: null, notario: '' }];
            }
        }
        //TIPO AUTORIZACION
        if (JSON.parse(localStorage.getItem("tipo_autorizacion"))) {
            if (JSON.parse(localStorage.getItem("tipo_autorizacion")).length > 0) {
                this.tipo_autorizacion = JSON.parse(localStorage.getItem("tipo_autorizacion"));
            }
            else {
                localStorage.setItem("tipo_autorizacion", JSON.stringify([]));
                this.tipo_autorizacion = [{ autorizacion: '' }];
            }
        }
        //CIP
        if (JSON.parse(localStorage.getItem("cip"))) {
            if (JSON.parse(localStorage.getItem("cip")).length > 0) {
                this.cip = JSON.parse(localStorage.getItem("cip"));
            }
            else {
                localStorage.setItem("cip", JSON.stringify([]));
                this.cip = [{ certcip: '', fecha_cip: '' }];
            }
        }
        //REGISTRO DE BIENES
        if (JSON.parse(localStorage.getItem("registro_bienes"))) {
            if (JSON.parse(localStorage.getItem("registro_bienes")).length > 0) {
                this.registro_bienes = JSON.parse(localStorage.getItem("registro_bienes"));
            }
            else {
                localStorage.setItem("registro_bienes", JSON.stringify([]));
                this.registro_bienes = [{ inscrito: '', numero: '', anio: '', bienes: '' }];
            }
        }
        //PROFESIONAL COMPETENTE
        if (JSON.parse(localStorage.getItem("profesionalComp"))) {
            if (JSON.parse(localStorage.getItem("profesionalComp")).length > 0) {
                this.profesionalComp = JSON.parse(localStorage.getItem("profesionalComp"));
            }
            else {
                localStorage.setItem("profesionalComp", JSON.stringify([]));
                this.profesionalComp = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' }];
            }
        }
        //EMPRESAS
        if (JSON.parse(localStorage.getItem("empresas"))) {
            if (JSON.parse(localStorage.getItem("empresas")).length > 0) {
                this.empresas = JSON.parse(localStorage.getItem("empresas"));
            }
            else {
                localStorage.setItem("empresas", JSON.stringify([]));
                this.empresas = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' }];
            }
        }
        //PERMISO DEMOLICION
        if (JSON.parse(localStorage.getItem("permiso_demolicion"))) {
            if (JSON.parse(localStorage.getItem("permiso_demolicion")).length > 0) {
                this.permiso_demolicion = JSON.parse(localStorage.getItem("permiso_demolicion"));
            }
            else {
                localStorage.setItem("permiso_demolicion", JSON.stringify([]));
                this.permiso_demolicion = [{ perm_numero: '', perm_fecha: '', solicitud: '' }];
            }
        }
    };
    Formulario58Component.prototype.captureScreen = function () {
        var _this = this;
        var pdf = new jspdf('p', 'mm', 'a4');
        this.htmlcanvas(document.getElementById("page1")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page2")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page3")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        setTimeout(function () {
            pdf.save(_this.propietarios[0].rut + '.pdf');
            // pdf.save('prueba.pdf')
        }, 6000);
    };
    return Formulario58Component;
}());
export { Formulario58Component };
